export default __webpack_public_path__ + "static/media/sold-out-badge.af9944a6.svg";